interface HomeRedirectInput {
  isAuthenticated: boolean;
  roles: string[];
}

export function getHomeRedirectTarget({ isAuthenticated, roles }: HomeRedirectInput): string {
  if (!isAuthenticated) {
    return '/login';
  }

  const hasRole = (role: 'ADMIN' | 'OPERATIONS' | 'SALES' | 'GM' | 'CLIENT') =>
    roles.some((userRole) => userRole.toLowerCase() === role.toLowerCase());

  // Priority matches login-page post-login redirect: ADMIN > OPERATIONS > SALES > GM > CLIENT.
  if (hasRole('ADMIN')) {
    return '/admin';
  }

  if (hasRole('OPERATIONS')) {
    return '/operations';
  }

  if (hasRole('SALES')) {
    return '/sales/quotes';
  }

  if (hasRole('GM')) {
    return '/gm/quotes';
  }

  if (hasRole('CLIENT')) {
    return '/client/dashboard';
  }

  return '/login';
}
